import { forwardRef, InputHTMLAttributes, useId } from 'react';

import { typography } from '@ui';

import * as css from './Input.css';

type UserSettingsInputProps = InputHTMLAttributes<HTMLInputElement> & {
    label: string;
};

export const Input = forwardRef<HTMLInputElement, UserSettingsInputProps>(({ label, ...props }, ref) => {
    const id = useId();
    return (
        <div className={css.inputField}>
            <label htmlFor={id} className={typography({ variant: 'h4' })}>
                {label}
            </label>
            <input id={id} className={css.input} ref={ref} {...props} />
        </div>
    );
});

Input.displayName = 'UserSettingsInput';
